import { injectIntl } from "react-intl";
import React, { useState } from "react";
import { OperationType } from "src/helpers/Enums";
import apiService from "src/services/api.service";

const NewTag = (props) => {

    const [tag, setTag] = useState(props.type === OperationType.UPDATE ? props.tag : {name: "",})

    const handleName = (name) => {
        setTag({...tag, name: name})
    };

    const createUpdateTag = () => {
        switch (props.type) {
            case OperationType.CREATE:
                apiService.createTag(tag).then(() => {
                    props.close()
                })
                break
            case OperationType.UPDATE:
                apiService.updateTag(tag).then(() => {
                    props.close()
                })
                break
        }
    }

    const isEnableButton = () => {
        let isEnable = false
        if (tag?.name) {
            isEnable = true
        }
        return isEnable
    }

    return (
        <div className="NewStrategyModalOverlay">
            <div className="NewStrategyModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ props.type === OperationType.CREATE ? "NewStrategy" : "NewCreative" }>
                        <img alt={ "Logo" }
                             src={ props.type === OperationType.CREATE ? "/media/icons/purplePlusIcon.svg" : "/media/icons/editIcon.svg" }
                             className={ "w-[18px] h-[18px]" }/>
                        { props.type === OperationType.CREATE ? "New" : "Edit" } Tag
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>

                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Tag Name</div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleName(e.target.value) } value={ tag?.name }/>
                </div>
                <div className="modal-actions">
                    <button type="button" onClick={ props.close } className="CloseButton">
                        Close
                    </button>
                    <button className="CreateButton" disabled={ !isEnableButton() } onClick={ createUpdateTag }>
                        { props.type === OperationType.CREATE ? "Create" : "Save" }
                    </button>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(NewTag);
